export default "__VITE_ASSET__DtkNCG9a__"